import type { Locale } from "date-fns";

export class EventDate {
    public readonly timestamp: number;
    public readonly day: string;
    public readonly month: string;
    public readonly year: string;
    public readonly time: string;
    public readonly timezone: string;

    public constructor(passedDate: Date | number, locale: Locale, tz: string) {
        const date = new Date(passedDate);

        if (date && date.getTime() > 0) {
            const formatterTimezone = {timeZone: !tz || tz === 'Z' ? 'UTC' : tz};

            const localeCode = locale?.code || 'en-US';
            const dayFormatter = new Intl.DateTimeFormat(localeCode, {...formatterTimezone, day: '2-digit'});
            const monthFormatter = new Intl.DateTimeFormat(localeCode, {...formatterTimezone, month: 'long'});
            const yearFormatter = new Intl.DateTimeFormat(localeCode, {...formatterTimezone, year: 'numeric'});
            const timeFormatter = new Intl.DateTimeFormat(localeCode, {...formatterTimezone, hour: '2-digit', minute: '2-digit'});

            this.timestamp = date.getTime();
            this.day = dayFormatter.format(date);
            this.month = monthFormatter.format(date);
            this.year = yearFormatter.format(date);
            this.time = timeFormatter.format(date);
            this.timezone = tz && tz !== 'Z' ? tz : '';
        }
    }

    public isValid(): boolean {
        return !!this.timestamp;
    }
}

export function isSameDayFunction(date1: EventDate, date2: EventDate): boolean {
    return date1.day === date2?.day && date1.month === date2?.month && date1.year === date2?.year;
}